import { render } from "./Index.vue?vue&type=template&id=4672c242&scoped=true"
const script = {}

import "./Index.vue?vue&type=style&index=0&id=4672c242&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4672c242"

export default script